import Catalogos_reducer from './Catalogos_reducer';
import { combineReducers } from 'redux';
const rootReducer = combineReducers({
    catalogos_reducer: Catalogos_reducer
})
export default rootReducer;